import { Component, Input } from '@angular/core';
import { PorcentajePromo, EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

/**
 * Tarjeta para promos globales por Tipo Cliente OL (condicion='T'): no tienen
 * un articulo/foto propios (aplican sobre todo el carrito, no un producto
 * puntual), asi que no pueden usar <promocion-card> tal cual - esa depende de
 * getArticulo1()/getFotoImagen() para renderizar.
 */
@Component({
  selector: 'promocion-global-card',
  templateUrl: './promocion-global-card.component.html',
  styleUrls: ['./promocion-global-card.component.scss']
})
export class PromocionGlobalCardComponent {
  @Input() promocion: PorcentajePromo;

  constructor(public genServ: EcommerceGenericoService) { }

  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio();
  }
}
